
import Swal from "sweetalert2";
import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { UIActions } from "../../../presentation/redux/actions/UIActions";
import { errorManager } from "../../../presentation/utils/errorManager";

export const resendEmailValidation = (tmpData) => async (dispatch) => {
  const {puntoVenta, uid } = tmpData;
  try {
    // dispatch(UIActions.uiLoadActive());
    const params = new URLSearchParams({
      pointOfSale: puntoVenta,
      ...(uid && { user: uid }) 
    });
    const response = await fetch(`${RemoteConstants.BASE_URL}pos/resend/email/code?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (data.code === 'OK') {
      Swal.fire('Enviado', data.userMessage, 'success');
    } else {
      errorManager(data.userMessage);
    }
  } catch (error) {
    errorManager(error)
  }
  dispatch(UIActions.uiLoadInactive());
}